export default __webpack_public_path__ + "static/media/PerwiraMiles.7adfb067.svg";